'use strict';
import BamGameUtils from 'bam-game-utils';
const BamButtonGroup = BamGameUtils.getBamButtonGroupClass();

// MLB-specific allowed keys to add to ALLOWED_KEYS in superclass:
const SUPPLEMENTARY_ALLOWED_KEYS = ['boxscore', 'gameday', 'notes', 'fgow', 'youtubefgow'];

/**
 * Subclass of BamButtonGroup.  At present, we don't override any of its functionality.
 * @extends BamButtonGroup
 */
class MlbButtonGroup extends BamButtonGroup {

    /**
     * @constructor
     */
    constructor() {
        super(SUPPLEMENTARY_ALLOWED_KEYS);
    }

    /**
     * @see superclass docs; overriding this only to make it public
     * @public
     */
    addButton(key, bamButton) {
        super.addButton(key, bamButton);
    }

}

export default MlbButtonGroup;

